/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RediscoverResponse {
    getFixupPrototypeFunction() { return RediscoverResponse.fixupPrototype; }

    static newInstance(model: Partial<RediscoverResponse>): RediscoverResponse {
        let obj = Object.assign(new RediscoverResponse(), model);
        RediscoverResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RediscoverResponse>): RediscoverResponse {
        if (!model) return null;
        return RediscoverResponse.newInstance(<RediscoverResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RediscoverResponse) {
        if (!obj) return;

        models.RediscoverResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RediscoverResponse): boolean {
        Object.setPrototypeOf(obj, RediscoverResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Account Details
     */
    cloud_account: Array<any>;

}
